export interface Volume {
  volume: string
  title: string
  lead: string
  body: string
  listLabel: string
  items: string[]
}

export const volumes: Volume[] = [
  {
    volume: 'Volume I',
    title: 'The Case Before the Paper',
    lead: 'Learn what to analyze before turning a mark into a clinical decision.',
    body: 'Build a complete view of the case and organize the information you need to consider before beginning the refinement stage.',
    listLabel: 'You’ll discover:',
    items: [
      'The Occlusion 360™ framework',
      'The complete analysis sequence',
      'What to observe before using articulating paper',
      'Key questions to ask',
      'Common analysis mistakes',
      'Pre-refinement checklist',
      'Observation map',
    ],
  },
  {
    volume: 'Volume II',
    title: 'The Morphofunctional Map',
    lead: 'Learn how to organize your observations before deciding what should be modified.',
    body: 'A visual reference designed to help you structure your observations and understand how morphology and function contribute to case interpretation.',
    listLabel: 'You’ll receive:',
    items: [
      'Morphofunctional analysis map',
      'Regional observation framework',
      'Key characteristics to evaluate',
      'What to preserve',
      'What to question',
      'Comparison tables',
      'Visual guides',
      'Quick-reference sheets',
    ],
  },
  {
    volume: 'Volume III',
    title: 'The Occlusal Decision System',
    lead: 'Stop going directly from “I see something” to “I should adjust it.”',
    body: 'Learn to separate OBSERVATION → INTERPRETATION → HYPOTHESIS → DECISION so you can organize your reasoning before intervening.',
    listLabel: 'You’ll receive:',
    items: [
      'Decision trees',
      'Analysis matrices',
      'Decision checkpoints',
      'Clinical reasoning framework',
      'Common reasoning errors',
      'Educational case scenarios',
      'The complete Occlusion 360™ framework',
    ],
  },
  {
    volume: 'Volume IV',
    title: 'Put the Articulating Paper in Its Right Place',
    lead: 'Learn how to integrate articulating paper into your process as a refinement tool — not as your only starting point.',
    body: 'Discover how to interpret marks within the broader context of the case.',
    listLabel: 'You’ll learn about:',
    items: [
      'Where articulating paper fits into the overall sequence',
      'How to interpret markings in context',
      'Observation vs. conclusion',
      'Refinement',
      'Verification',
      'Common mistakes',
      'Refinement checklist',
    ],
  },
  {
    volume: 'Volume V',
    title: 'The Cases That Make You Hesitate',
    lead: 'Train your clinical reasoning by working through educational cases before seeing the analysis.',
    body: 'A practical case library designed to help you develop a more structured way of thinking when the case isn’t straightforward.',
    listLabel: 'Includes:',
    items: [
      'Rehabilitated cases',
      'Post-orthodontic scenarios',
      'Cases with conflicting information',
      'Reassessment scenarios',
      'Common clinical situations',
      'Analysis questions',
      'Possible interpretations',
      'Case discussions',
      'Key takeaways',
    ],
  },
  {
    volume: 'Volume VI',
    title: 'Validation & Closure',
    lead: 'Organize the final stage so you can document, verify, and close the process with greater confidence.',
    body: 'Because analysis doesn’t end with a mark.',
    listLabel: 'You’ll receive:',
    items: [
      'Validation checklist',
      'Before-and-after documentation framework',
      'Decision record',
      'Final review checklist',
      'Closure checklist',
      'Follow-up framework',
      'Common closing errors',
      'Occlusion 360™ documentation system',
    ],
  },
]

export interface Extra {
  icon: string
  title: string
  description: string
}

export const extras: Extra[] = [
  {
    icon: '🧠',
    title: 'Decision Maps',
    description:
      'Visual pathways to help organize your analysis before reaching the refinement stage.',
  },
  {
    icon: '📋',
    title: 'Professional Checklists',
    description:
      'Practical reference tools designed to help standardize your analysis and review process.',
  },
  {
    icon: '🦷',
    title: 'Morphofunctional Map',
    description:
      'A visual reference for organizing what you observe before making decisions.',
  },
  {
    icon: '📊',
    title: 'Analysis Matrices',
    description:
      'Tools designed to help separate findings, hypotheses, and decisions.',
  },
  {
    icon: '📸',
    title: 'Documentation System',
    description:
      'Templates for organizing the process and documenting before-and-after information.',
  },
]
